export const IDE_HEADER_HEIGHT = 40;
